<template>
  <div class="content">
    <section class="page-intro">
      <p>
        <span class="f-ticker">Skullcandy</span>
        <span class="accent-1"> • </span>
        <span class="f-ticker">2021</span>
        <span class="accent-1"> &#8212; </span>
        <span class="f-ticker">Rally Interactive</span>
      </p>
      <p class="tag-list">
        <span class="tag icon-text">UX</span>
        <span class="tag icon-text">•</span>
        <span class="tag icon-text">UI</span>
        <span class="tag icon-text">•</span>
        <span class="tag icon-text">Blender</span>
        <span class="tag icon-text">•</span>
        <span class="tag icon-text">Animation</span>
      </p>
    </section>

    <section class="image-gallery">
      <div class="row">
        <div class="column">
          <p>
            <img
              src="@/assets/images/skullcandy/plyr_renders.png"
              alt="Product cards design"
            />
          </p>
          <p>
            <img src="@/assets/images/skullcandy/skdy_wires.png" alt="Wires" />
          </p>
          <p>
            <img src="@/assets/images/skullcandy/skdy_gaming.png" alt="Wires" />
          </p>
          <p>
            <img
              src="@/assets/images/skullcandy/Product_Cards.png"
              alt="Product cards design"
            />
          </p>
          <p>
            <img
              src="@/assets/images/skullcandy/Battery_Exploration.png"
              alt="Battery widget explorations"
            />
          </p>
          <div class="row three-columns row-no-padding">
            <div class="column">
              <img
                src="@/assets/images/skullcandy/10-Band A.png"
                alt="10-band equalizer interface A"
              />
            </div>
            <div class="column">
              <img
                src="@/assets/images/skullcandy/10-Band B.png"
                alt="10-band equalizer interface B"
              />
            </div>
            <div class="column">
              <img
                src="@/assets/images/skullcandy/10-Band C.png"
                alt="10-band equalizer interface C"
              />
            </div>
          </div>
          <p>
            <img
              src="@/assets/images/skullcandy/Color_Primary.png"
              alt="Primary color palette"
            />
          </p>
          <p>
            <img
              src="@/assets/images/skullcandy/Color_Typography.png"
              alt="Typographic colors"
            />
          </p>
          <p>
            <img
              src="@/assets/images/skullcandy/Typography_App.png"
              alt="Typography scale"
            />
          </p>
        </div>
      </div>
    </section>
    <ViewMoreWork
      :previous-project="{ path: '/work/otter', name: 'Otter' }"
      :next-project="{ path: '/work/odyssey', name: 'Odyssey' }"
    />
  </div>
</template>

<style lang="scss" scoped>
.main-content {
  opacity: 1;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(256px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

img.animate {
  animation: fadeInUp 0.3s ease-out forwards;
}
</style>

<script setup>
import { defineExpose, onMounted } from "vue";
import { useAssetPreloader } from "@/composables/useAssetPreloader.js";
import ViewMoreWork from "@/components/projects/ViewMoreWork.vue";

// Define preload function that will be called before component is mounted
const preload = async () => {
  const { preloadAssets } = useAssetPreloader();

  // Specify exactly which assets this page needs
  const assets = [
    (await import("@/assets/images/skullcandy/Product_Cards.png")).default,
    (await import("@/assets/images/skullcandy/01B Search.png")).default,
    (await import("@/assets/images/skullcandy/01a Detected Known.png")).default,
    (await import("@/assets/images/skullcandy/03a FOTA Available.png")).default,
  ];

  await preloadAssets(assets);
};

onMounted(() => {
  const projects = document.querySelectorAll("img");
  projects.forEach((project, index) => {
    setTimeout(() => {
      project.classList.add("animate");
    }, index * 100);
  });
});

// Expose preload method for external use
defineExpose({ preload });
</script>
